// extracted by mini-css-extract-plugin
export var materialIcons = "project-preview-grid-module--material-icons--nHERq";
export var root = "project-preview-grid-module--root--osSFd";
export var headline = "project-preview-grid-module--headline--k1CuT";
export var grid = "project-preview-grid-module--grid--7frOn";
export var browseMoreNav = "project-preview-grid-module--browseMoreNav---MykF typography-module--small--KHf9L";